import { makeStyles } from "@mui/styles";
import { COLORS } from "../../../constant/colors";

export default makeStyles(() => ({
  categorySec: {
    padding: "80px 0",
    background: `linear-gradient(135deg, ${COLORS.backgroundLight} 0%, ${COLORS.cream} 100%)`,
    marginBottom: 0,
    "@media (max-width: 600px)": {
      padding: "30px 0 40px",
    },
  },
  sectionHeader: {
    textAlign: "center",
    marginBottom: 30,
    "@media (max-width: 600px)": {
      marginBottom: 15,
    },
  },
  heading: {
    fontSize: "2.5rem",
    fontWeight: 700,
    color: COLORS.textPrimary,
    marginBottom: 16,
    fontFamily: "'Poppins', sans-serif",
    position: "relative",
    "&::after": {
      content: '""',
      position: "absolute",
      bottom: -8,
      left: "50%",
      transform: "translateX(-50%)",
      width: 60,
      height: 4,
      background: `linear-gradient(90deg, ${COLORS.primary} 0%, ${COLORS.secondary} 100%)`,
      borderRadius: 2,
    },
    "@media (max-width: 600px)": {
      fontSize: "1.8rem",
      marginBottom: 12,
    },
  },
  subheading: {
    fontSize: "1.1rem",
    color: COLORS.textSecondary,
    maxWidth: 600,
    margin: "0 auto !important",
    lineHeight: 1.6,
    fontFamily: "'Poppins', sans-serif",
    "@media (max-width: 600px)": {
      fontSize: "0.9rem",
    },
  },
  categoriesGrid: {
    display: "grid",
    gridTemplateColumns: "repeat(auto-fit, minmax(280px, 1fr))",
    gap: 30,
    maxWidth: 1200,
    margin: "0 auto",
    "@media (max-width: 768px)": {
      gridTemplateColumns: "repeat(auto-fit, minmax(250px, 1fr))",
      gap: 20,
    },
    "@media (max-width: 480px)": {
      gridTemplateColumns: "1fr",
      gap: 16,
    },
  },
  categoryCard: {
    position: "relative",
    borderRadius: 20,
    overflow: "hidden",
    height: 280,
    display: "flex",
    flexDirection: "column",
    textDecoration: "none",
    transition: "all 0.4s cubic-bezier(0.4, 0, 0.2, 1)",
    boxShadow: "0 8px 32px rgba(0, 0, 0, 0.1)",
    "&:hover": {
      transform: "translateY(-8px)",
      boxShadow: "0 20px 40px rgba(0, 0, 0, 0.15)",
    },
    "&:hover $categoryOverlay": {
      opacity: 1,
      transform: "translateY(0)",
    },
    "@media (max-width: 480px)": {
      height: 240,
    },
  },
  categoryImage: {
    position: "absolute",
    top: 0,
    left: 0,
    width: "100%",
    height: "100%",
    "& img": {
      width: "100%",
      height: "100%",
      objectFit: "cover",
      transition: "transform 0.4s ease",
    },
    "&:hover img": {
      transform: "scale(1.05)",
    },
  },
  categoryOverlay: {
    position: "absolute",
    bottom: 0,
    left: 0,
    right: 0,
    background: "linear-gradient(transparent, rgba(0, 0, 0, 0.8))",
    padding: "40px 24px 24px",
    color: COLORS.white,
    opacity: 0.9,
    transform: "translateY(10px)",
    transition: "all 0.3s ease",
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
  },
  categoryName: {
    fontSize: "1.5rem",
    fontWeight: 600,
    margin: 0,
    color: COLORS.white,
    fontFamily: "'Poppins', sans-serif",
    "@media (max-width: 480px)": {
      fontSize: "1.3rem",
    },
  },
  categoryArrow: {
    width: 40,
    height: 40,
    borderRadius: "50%",
    background: "rgba(255, 255, 255, 0.2)",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    transition: "all 0.3s ease",
    "& svg": {
      color: COLORS.white,
    },
    "&:hover": {
      background: "rgba(255, 255, 255, 0.3)",
      transform: "scale(1.1)",
    },
  },
}));
